export class LicenseDetails {
  public licenseTypeCode: string = null;
  public description: string = null;
  public yearOfFirstIssue: number = null;
  public numberOfClaims: number = null;

  constructor() {
  }
}
